import { computed, unref, type ComputedRef, type MaybeRef } from 'vue'
import type { PaymentMethodType } from '@/services/premiumService/PremiumService'

/** New payment methods are represented by their type; existing ones by their id. */
export const NEW_PAYMENT_METHOD_TYPES: PaymentMethodType[] = ['CREDIT_CARD', 'SEPA', 'PAYPAL']

/**
 * Resolves the payment method type enum to send to the backend.
 *
 * `selectedPaymentMethod` holds a type string for a newly added method
 * (CREDIT_CARD | SEPA | PAYPAL), or a payment-method id for an existing one — in which
 * case the type (incl. WIRE_TRANSFER) is looked up from `existingPaymentMethods`.
 */
export function useSelectedPaymentMethodType(
  selectedPaymentMethod: MaybeRef<string | null | undefined>,
  existingPaymentMethods: MaybeRef<ReadonlyArray<{ id: string; type: PaymentMethodType }> | null | undefined>
): ComputedRef<PaymentMethodType | undefined> {
  return computed(() => {
    const selected = unref(selectedPaymentMethod)
    if (!selected) return undefined
    if ((NEW_PAYMENT_METHOD_TYPES as string[]).includes(selected)) return selected as PaymentMethodType
    return unref(existingPaymentMethods)?.find(method => method.id === selected)?.type
  })
}
